"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEntityFromElement_1 = require("./getEntityFromElement");
/**
 * @internal
 * Try to trigger an EntityOperation event with a given element. An event will only be
 * triggered when the specified is an element root element.
 * @param editor The editor which contains the entity
 * @param element The root element of the entity
 * @param operation Operation of the EntityOperation event
 * @param rawEvent (Optional) Original UI event which causes this event
 */
function tryTriggerEntityEvent(editor, element, operation, rawEvent) {
    var entity = element && getEntityFromElement_1.default(element);
    if (entity) {
        if (operation == 0 /* NewEntity */ && entity.isReadonly) {
            element.contentEditable = 'false';
        }
        editor.triggerPluginEvent(16 /* EntityOperation */, {
            operation: operation,
            rawEvent: rawEvent,
            entity: entity,
        });
    }
}
exports.default = tryTriggerEntityEvent;
//# sourceMappingURL=tryTriggerEntityEvent.js.map